import api from './api';

export const remindersService = {
    async getReminders(params = {}) {
        const response = await api.get('/reminders/reminders/', { params });
        return response.data;
    },

    async createReminder(data) {
        const response = await api.post('/reminders/reminders/', data);
        return response.data;
    },

    async updateReminder(id, data) {
        const response = await api.patch(`/reminders/reminders/${id}/`, data);
        return response.data;
    },

    async deleteReminder(id) {
        await api.delete(`/reminders/reminders/${id}/`);
    },

    async markAsRead(id) {
        const response = await api.patch(`/reminders/reminders/${id}/`, { is_read: true });
        return response.data;
    },

    async markAsUnread(id) {
        const response = await api.patch(`/reminders/reminders/${id}/`, { is_read: false });
        return response.data;
    },

    async getUnreadReminders() {
        const response = await api.get('/reminders/reminders/', {
            params: { is_read: false }
        });
        return response.data;
    },

    async snoozeReminder(id, snoozeUntil) {
        const response = await api.patch(`/reminders/reminders/${id}/`, {
            snoozed_until: snoozeUntil
        });
        return response.data;
    },

    // Schedule management
    async getSchedules(params = {}) {
        const response = await api.get('/reminders/schedules/', { params });
        return response.data;
    },

    async createSchedule(data) {
        const response = await api.post('/reminders/schedules/', data);
        return response.data;
    },

    async updateSchedule(id, data) {
        const response = await api.patch(`/reminders/schedules/${id}/`, data);
        return response.data;
    },

    async deleteSchedule(id) {
        await api.delete(`/reminders/schedules/${id}/`);
    },

    // Preferences management
    async getPreferences() {
        const response = await api.get('/reminders/preferences/');
        return response.data;
    },

    async updatePreferences(data) {
        const response = await api.post('/reminders/preferences/', data);
        return response.data;
    }
}; 